/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

import $ from "./app/jquery-shim";

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {
  }

  growApp.prototype.shopView = function () {
    const defaultOptions = {
      blocks: '.js-view-targets',
      images: '.js-view-gallery',
      anchors: '.js-view-anchor'
    }

    class View {
      constructor() {
        this.options = defaultOptions;
        this.init();
      }

      init() {
        let $window = $(window).innerWidth();
        if ($window < 750) {
          return false;
        }
        this.fetchDom();
      }

      fetchDom(){
        this.blocksEle = $(this.options.blocks);
        this.imagesEle = $(this.options.images);
        this.anchorsEle = $(this.options.anchors);
        if (this.blocksEle.length === 0 || this.imagesEle.length === 0 || this.anchorsEle.length === 0) {
          return false;
        }
        this.run();
      }

      run(){
        let $imagesTargets = this.imagesEle.children();
        let $anchorTargets = this.anchorsEle.children();
        $anchorTargets.bind('mousemove',function (){
          let i = $(this).index();
          $imagesTargets.removeClass('is-active');
          $imagesTargets.eq(i).addClass('is-active');
        });
      }
    }
    new View;
  }

  growApp.prototype.accordionTextChange = function () {
    let $target = $('.js-text-changer');
    let $targetText = $('.js-text-changer-text span');

    $target.on('click', function() {
      if ($target.hasClass('is-open')) {
        $targetText.text('商品詳細を閉じる');
      }else{
        $targetText.text('商品詳細をみる');
      }
    })
  }
  growApp.prototype.groupList = function () {
    let $target = $('.js-group-list');
    if (!$target) return false;

    let $targetItem = $target.find($('.c-box-group-links__item'));
    if ($targetItem.length <= 3) {
      $target.addClass('is-center');
    }
  }


  $(function () {
    var app = new growApp();
    app.myCode();
    app.shopView();
    app.accordionTextChange();
    // app.groupList();
    // app.enterAnimation()
  });
})(jQuery);
